import React, { useCallback, useState } from 'react';

import { Box } from '@rbilabs/universal-components';
import { useWindowDimensions } from 'react-native';

import Picture from 'components/picture';
import { useTopOrderStatusBar } from 'components/top-order-status-bar/use-top-order-status-bar';
import { useHideTsmPointsNotificationLoyaltyBannerExperiment } from 'experiments/hide-tsm-pointsnotification-loyaltybanner/use-enable-item-detail-reorder-experiment';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useStoreContext } from 'state/store';
import { isNativeIOS } from 'utils/environment';
import { EventName, emitEvent } from 'utils/event-hub';

import { CTAButtons } from '../components/cta-button';
import { ISimpleHomePageProps } from '../types';

import { FooterContainer, HeaderContainer, HeaderStyled, HeroSection } from './styled';

const _SimpleHomePageMobile = ({
  navigate,
  numberOfItemsInCart,
  serviceMode,
  item,
}: ISimpleHomePageProps) => {
  const dimension = useWindowDimensions();
  const hideTsmAndLoyaltyCtaBarOnHome = useHideTsmPointsNotificationLoyaltyBannerExperiment();
  const showLoyaltyBannerV1 = useFlag(LaunchDarklyFlag.SHOW_LOYALTY_BANNER_V1);
  const { noStoreSelected } = useStoreContext();
  const topOrderStatusBarData = useTopOrderStatusBar();
  const [buttonsHeight, setButtonsHeight] = useState(100);
  const TSM_HEIGHT = 48;
  const RB_HEIGHT = 75;
  // this is needed bc on IOS we have more spacing at top and bottom
  const BOTTOM_NAV_HEIGHT = isNativeIOS() ? 100 : 65;
  const HEADER_HEIGHT = isNativeIOS() ? 117 : 77;
  let availableHeight = dimension.height - HEADER_HEIGHT - BOTTOM_NAV_HEIGHT;
  if (
    (!noStoreSelected && !hideTsmAndLoyaltyCtaBarOnHome) ||
    (topOrderStatusBarData.queryWasExecuted && topOrderStatusBarData.heading)
  ) {
    availableHeight -= TSM_HEIGHT;
  }

  if (showLoyaltyBannerV1 && !hideTsmAndLoyaltyCtaBarOnHome) {
    availableHeight -= RB_HEIGHT;
  }

  const { header, mobileImage, altImageText, _id } = item;
  const headerText = header?.locale ?? '';
  const imageAlt = altImageText?.locale ?? '';
  const image = mobileImage?.locale;

  const onImageLoaded = useCallback(() => {
    emitEvent(EventName.MARKETING_IMAGE_LOADED);
  }, []);

  return (
    <HeroSection testID="simple-home-page" height={availableHeight}>
      <Box height={availableHeight - buttonsHeight}>
        <Picture
          height="full"
          image={image}
          alt={imageAlt}
          onImageLoaded={onImageLoaded}
          width={dimension.width}
        />
      </Box>
      <FooterContainer
        onLayout={event => {
          setButtonsHeight(event.nativeEvent.layout.height);
        }}
      >
        <HeaderContainer accessibilityLabel={headerText}>
          <HeaderStyled>{headerText}</HeaderStyled>
        </HeaderContainer>
        <CTAButtons
          numberOfItemsInCart={numberOfItemsInCart}
          serviceMode={serviceMode}
          navigate={navigate}
          itemId={_id}
        />
      </FooterContainer>
    </HeroSection>
  );
};

export const SimpleHomePageMobile = React.memo(_SimpleHomePageMobile);
